import React from 'react';
import { HotelAvailabilityErrors, HotelExtraType, TripType, useGlobalContext } from '@honeycomb/data';
import { Stacker, TypographyBody, Divider, Notification, WarningIcon, Scrollbars, Styler } from '@honeycomb/ui-core';
import { useHotelBasketContext } from '../../HotelBasketProvider';
import { HotelBasketContentRegion, HotelBasketRoomUnavailable } from '.';
import { HotelConfirmSelectionButton } from '../HotelConfirmSelectionButton';
import { HotelBasketFlights, HotelBasketRooms, HotelBasketTotal, HotelBasketTransfer } from './HotelBasketComponents';
import { useTripTypeFromTrip } from '../../../../utils';
export function HotelBasket({ withCTA = false, withContentRegion = false, hidePriceToggle = false, }) {
    var _a, _b;
    const { resourceStrings: { BASKET_PRICEMESSAGE, HOTEL_BASKET_ERROR_HEADING, HOTEL_BASKET_ERROR_SUB_HEADING }, } = useGlobalContext();
    const tripType = useTripTypeFromTrip();
    const flightsIncluded = tripType === TripType.Holiday;
    const { hotelBasket: { selectedRooms, waitingForFlights, waitingForRooms, availabilityErrors }, } = useHotelBasketContext();
    const hasMandatoryTransfer = (_b = (_a = selectedRooms === null || selectedRooms === void 0 ? void 0 : selectedRooms[0]) === null || _a === void 0 ? void 0 : _a.pricingSummary.includedExtras) === null || _b === void 0 ? void 0 : _b.some((extras) => extras === HotelExtraType.Transfer);
    const isWaitingForSelection = flightsIncluded ? waitingForFlights || waitingForRooms : waitingForRooms;
    // TODO: for holiday it could be the flight that is not available, yet we are displaying a message about rooms.
    const hasRooms = (selectedRooms === null || selectedRooms === void 0 ? void 0 : selectedRooms.length) > 0;
    const hasBasketError = availabilityErrors.includes(HotelAvailabilityErrors.BASKET_ERROR);
    // Availability error
    if (hasBasketError) {
        return (React.createElement(Styler, { pb: 5, "data-default-gutters": true },
            React.createElement(Notification, { color: "error", icon: React.createElement(WarningIcon, null) },
                React.createElement(TypographyBody, { weight: "bold" }, HOTEL_BASKET_ERROR_HEADING),
                HOTEL_BASKET_ERROR_SUB_HEADING)));
    }
    // No selection error
    if (!isWaitingForSelection && !hasRooms) {
        return (React.createElement(Styler, { pb: 5, "data-default-gutters": true },
            React.createElement(HotelBasketRoomUnavailable, null)));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Scrollbars, { mih: flightsIncluded ? 220 : 100, py: 2, flexGrow: 1, "data-default-gutters": true },
            React.createElement(Stacker, { spacing: 2 },
                React.createElement(HotelBasketRooms, null),
                flightsIncluded && React.createElement(HotelBasketFlights, null),
                hasMandatoryTransfer && React.createElement(HotelBasketTransfer, null))),
        React.createElement(Styler, { pb: 2, "data-default-gutters": true },
            React.createElement(Divider, { mb: 2 }),
            React.createElement(Stacker, { spacing: 4, flexShrink: 0, mb: 4 },
                React.createElement(HotelBasketTotal, { hidePriceToggle: hidePriceToggle }),
                React.createElement(TypographyBody, { mb: 1, size: "xs", ta: { m: 'center', xs: 'right' } }, BASKET_PRICEMESSAGE),
                withCTA && React.createElement(HotelConfirmSelectionButton, null),
                withContentRegion && React.createElement(HotelBasketContentRegion, null)))));
}
